import { Component, Input } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "myp-generic-alert",
  templateUrl: "generic-alert.component.html",
  standalone: false,
})
export class GenericAlertComponent extends BaseComponent {
  @Input() title: string = "";
  @Input() html: string = "";
  @Input() submitFn: Function;
  @Input() submitText: string = "Submit";
  @Input() closeText: string;

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService
  ) {
    super(userService);
    if (!this.closeText) this.closeText = this.translate.instant("general.close");
  }

  submit() {
    if (this.submitFn) {
      this.submitFn();
    }
    this.activeModal.close();
  }
}
